var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinc4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.400024,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#FCEBE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.999 51.2506L33.249 47.0006H37.499L40.389 44.1106C43.3431 45.1397 46.5591 45.1357 49.5106 44.099C52.4621 43.0623 54.9742 41.0545 56.6359 38.4041C58.2976 35.7536 59.0104 32.6177 58.6577 29.5094C58.3049 26.4011 56.9075 23.5046 54.6941 21.294C52.4807 19.0833 49.5824 17.6895 46.4737 17.3406C43.365 16.9918 40.2299 17.7085 37.5816 19.3735C34.9332 21.0385 32.9285 23.5532 31.8955 26.506C30.8626 29.4588 30.8625 32.6747 31.8954 35.6276L16.249 51.2506V59.7506H24.749L28.999 55.5006V51.2506Z",
    stroke: "#F78670",
    strokeWidth: 4.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.124 30.0001C49.2976 30.0001 50.249 29.0487 50.249 27.8751C50.249 26.7015 49.2976 25.7501 48.124 25.7501C46.9504 25.7501 45.999 26.7015 45.999 27.8751C45.999 29.0487 46.9504 30.0001 48.124 30.0001Z",
    stroke: "#F78670",
    strokeWidth: 4.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinc4);
export default __webpack_public_path__ + "static/media/WINC_4.fe607993ad8cdb0b1785eec71f65e22c.svg";
export { ForwardRef as ReactComponent };